import { PropsWithChildren } from "react";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Box, Button } from "@mui/material";

import BreadcrumbsStepper from "./BreadcrumbsStepper";
import SlideNavButtons from "./SlideNavButtons";

const SlideStepper = ({ children }: PropsWithChildren) => {
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        p: 4,
        width: "100%",
      }}
    >
      {children}
    </Box>
  );
};

const SlideStepperBreadcrumbs = BreadcrumbsStepper;
const SlidesStepperNavButtons = SlideNavButtons;

interface ICancelButtonProperties {
  cancelButtonText: string;
  handleCancel: () => void;
}

const SlideStepperCancelButton = ({ cancelButtonText, handleCancel }: ICancelButtonProperties) => {
  return (
    <Button
      color="error"
      endIcon={<CloseRoundedIcon />}
      onClick={handleCancel}
      sx={{ borderRadius: "8px" }}
      variant="contained"
    >
      {cancelButtonText ?? "Cancel"}
    </Button>
  );
};

export { SlidesStepperNavButtons, SlideStepper, SlideStepperBreadcrumbs, SlideStepperCancelButton };
